import {ApiModel} from '@models/api-model';
import {WorkingObjectNamespace} from '@namespaces/working-object.namespace';
import Status = WorkingObjectNamespace.Status;
import {SelectValueInterface} from '@interfaces/select-value.interface';

export class WorkingObject extends ApiModel<WorkingObjectNamespace.Interface> {
    static statuses: SelectValueInterface<Status>[] = [
        {id: Status.new,        title: 'Новый'},
        {id: Status.inWork,     title: 'В работе'},
        {id: Status.worksEnded, title: 'Работы завершены'},
        {id: Status.complete,   title: 'Объект принят'},
    ];

    statusTitle: string;

    constructor(
        data
    ) {
        super(data);
        this.setAttributes();
    }

    setAttributes() {
        this.statusTitle = this.getStatusTitle();
    }

    private getStatusTitle(): string {
        const status = WorkingObject.statuses.find(item => item.id === this.rawData.status);
        return status ? status.title : null;
    }
}
